<template>
  <div class="row">
    <div class="col-md-4 col-12">
      <EventListSearch
        :events="props.events"
        :search="search"
        :selected-event="selectedEvent"
        @update:search="onSearchUpdate"
        @select-event="selectEvent"
      />
    </div>
    <div class="col-md-8 col-12">
      <div class="card">
        <div class="card-body">
          <DashboardEvent v-if="selectedEvent" :event="selectedEvent" />
          <EmptyState
            v-else
            title="Selecciona un evento para ver el detalle."
            :size="400"
            fontSize="fs-6"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed } from "vue";
import DashboardEvent from "./dashboardEvent.vue";
import EventListSearch from "./eventListSearch.vue";
import EmptyState from "@/components/emptyState.vue";

const props = defineProps({
  events: {
    type: Array,
    required: true,
  },
});

const search = ref("");
const filteredEvents = ref(
  Array.isArray(props.events) ? [...props.events] : []
);
const selectedEvent = ref(null);

const totalEvents = computed(() =>
  Array.isArray(props.events) ? props.events.length : 0
);
const activeEvents = computed(() =>
  Array.isArray(props.events)
    ? props.events.filter((e) => e.state === 2).length
    : 0
);
const finishedEvents = computed(() =>
  Array.isArray(props.events)
    ? props.events.filter((e) => e.state === 3).length
    : 0
);

function searchEvents() {
  const term = search.value.toLowerCase();
  if (!term) {
    filteredEvents.value = Array.isArray(props.events) ? [...props.events] : [];
  } else {
    filteredEvents.value = Array.isArray(props.events)
      ? props.events.filter(
          (e) => e.title && e.title.toLowerCase().includes(term)
        )
      : [];
  }
  if (
    !filteredEvents.value.some(
      (e) => selectedEvent.value && e.id === selectedEvent.value.id
    )
  ) {
    selectedEvent.value = filteredEvents.value[0] || null;
  }
}

function onSearchUpdate(val) {
  search.value = val;
  searchEvents();
}

function selectEvent(event) {
  selectedEvent.value = event;
}

watch(
  () => props.events,
  (newEvents) => {
    filteredEvents.value = Array.isArray(newEvents) ? [...newEvents] : [];
    if (!selectedEvent.value && filteredEvents.value.length > 0) {
      selectedEvent.value = filteredEvents.value[0];
    }
  }
);
</script>
